module.exports = __webpack_public_path__ + "img/situation_logo.94e2329b.png";